module.exports = __webpack_public_path__ + "login-bg.a389a1f6c77f00d3c0c8.png";


//////////////////
// WEBPACK FOOTER
// /var/www/html/LASO/laso-client/src/img/login-bg.png
// module id = ../../../../../src/img/login-bg.png
// module chunks = main